import { addRest } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function UiGroup2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, [
        obj.name,
        obj.icon
            ? obj.icon + (obj.is_hidden ? 1 << 8 : 0) + (obj.hide_titles ? 1 << 9 : 0)
            : 0 + (obj.is_hidden ? 1 << 8 : 0) + (obj.hide_titles ? 1 << 9 : 0),
        obj.items,
        obj.position ?? 0,
        ...(obj.rest || []),
    ]);
}
function UiGroupFromStr(id, params) {
    return {
        id: id,
        name: params[0],
        is_hidden: Boolean((params[1] >> 8) & 0x01),
        hide_titles: Boolean((params[1] >> 9) & 0x01),
        icon: params[1] & 0xff,
        items: params[2],
        position: params[3] ?? 0,
        ...addRest(params, 4),
    };
}
export const ui_group_parser = {
    toStr: UiGroup2Str,
    fromStr: UiGroupFromStr,
};
